import { IconNames } from "../../components/Icon/types";

interface links {
  brand: string;
  headers: string[];
}

enum TagName {
  all = "all",
}

export const BrandLinks: links[] = [
  {
    brand: "biz-collection",
    headers: [
      "All",
      "Polos",
      "Tees",
      "Shirting & Tops",
      "Separates",
      "Knitwear",
      "Activewear",
      "Jackets",
      "Healthwear",
      "Hospitality",
      "Clearance",
    ],
  },
  {
    brand: "biz-corporates",
    headers: [
      "All",
      "New",
      "Women",
      "Men",
      "Shirts",
      "Blouses",
      "Pants",
      "Jackets",
      "Dresses",
      "Accessories",
      "Clearance",
    ],
  },
  {
    brand: "syzmik",
    headers: [
      "All",
      "Shirts & Polos",
      "Pants & Shorts",
      "Outerwear",
      "Overalls",
      "Fire Armour",
      "Clearance",
    ],
  },
  {
    brand: "syzmik-boots",
    headers: [],
  },
  {
    brand: "inaura",
    headers: [
      "All",
      "New",
      "Women",
      "Men",
      "Shirts",
      "Polos",
      "Pants",
      "Scrubs",
      "Accessories",
      "Clearance",
    ],
  },
];

export const returnIcon = (brand: string): IconNames => {
  switch (brand) {
    case "syzmik":
    case "syzmik-boots":
      return "Syzmik";
    case "biz-collection":
      return "BizCollection";
    case "biz-corporates":
      return "BizCorporates";
    case "good-mates":
      return "Goodmates";
    case "inaura":
      return "Inaura";

    default:
      return "FashionbizLogo";
  }
};

export const formatTag = (tagName: string): string =>
  tagName.toLowerCase().replace(/&/g, "and").trim();

export const returnLinkForTag = (tagName: string, isActive: boolean): string => {
  if (isActive) return "#";
  const tag = formatTag(tagName);
  if (tag === TagName.all) return "?page=1";
  if (tag === "new") return "?search=new+style,new+colour";
  return `?tag=${tag}`;
};
